<template>
  <div class="vimeoPlayer">
    <div ref="videoIframe" class="videoIframe"></div>
  </div>
</template>

<script>
import Player from '@vimeo/player';

export default {
  name: "VimeoPlayer",
  props: {
    videoUrl: String
  },
  data() {
    return {
      player: null,
    }
  },
  methods: {
    renderPlayer() {
      this.onUpdate = false;
      this.onUpdate = true;
      const iframe = this.$refs.videoIframe;
      this.player = new Player(iframe, {
        id: this.videoUrl,
        title: false,
        portrait: false,
        texttrack: false,
        pip: true,
        byline: false
      });
    },
    onChangeTime(val) {
      this.player.setCurrentTime(val);
    }
  },
  mounted() {
    this.renderPlayer();
  },
  watch: {
    videoUrl: function (newVal, oldVal) {
      this.player.loadVideo(newVal);
    }
  }
}
</script>

<style lang="scss">
.vimeoPlayer {
  .videoIframe {
    position:relative;
    padding-top:56.25%;
    iframe {
      position:absolute;
      top:0;
      left:0;
      width:100%;
      height:100%;
    }
  }
}
</style>